@let holdingData = holding();

<td-wb-modal-header class="td-wb-vh">
  <td-wb-modal-header-title modalTitle="tdWb.fpl.recall.HEADER" />
</td-wb-modal-header>
<td-wb-modal-panel [top]="true">
  <div class="td-wb-fpl-recall-security">
    <h3 class="td-wb-fpl-recall-security__header"
        aria-hidden="true"
        translate="tdWb.fpl.recall.HEADER"></h3>
    <div class="td-wb-fpl-recall-security__content">
      <td-wb-ticker-symbol-table-container class="td-wb-fpl-recall-security__symbol">
        @if (showLogo) {
          <td-wb-symbol-logo [svgString]="holdingData.logoLight"
                             [symbol]="holdingData.symbol?.tickerSymbol"
                             [market]="holdingData.symbol?.market"
                             [description]="holdingData.name" />
        }
        <td-wb-ticker-symbol [market]="holdingData.symbol?.market"
                             [tickerSymbol]="holdingData.symbol?.tickerSymbol"
                             [description]="holdingData.name" />
      </td-wb-ticker-symbol-table-container>
      <div class="td-wb-fpl-recall-security__content-shares">
        <div class="td-wb-fpl-recall-security__content-shares-label"
             translate="tdWb.fpl.recall.SHARES"></div>
        <div class="td-wb-fpl-recall-security__content-shares-value"
             [innerText]="numberOfShares()"></div>
      </div>
    </div>
    <div class="td-wb-fpl-recall-security__notification">
      <td-wb-notification notificationType="info">
        <div class="td-wb-fpl-recall-security__notification-content">
          <div translate="tdWb.fpl.recall.INFO_1"></div>
          <div translate="tdWb.fpl.recall.INFO_2"></div>
        </div>
      </td-wb-notification>
    </div>
    <div class="td-wb-fpl-recall-security__actions">
      <button id="td-wb-fpl-recall-security-cancel"
              class="td-wb-fpl-recall-security__actions-button"
              type="button"
              tdWbButton
              tdWbButtonType="secondary"
              tdWbModalClose
              (click)="cancelSecurityRecall()">
        <span translate="tdWb.fpl.recall.CANCEL"></span>
      </button>
      <button id="td-wb-fpl-recall-security-confirm"
              class="td-wb-fpl-recall-security__actions-button"
              type="submit"
              tdWbButton
              tdWbBlock="spinningAndBlock"
              [disabled]="disableRecall"
              tdWbButtonType="primary"
              (click)="handleSecurityRecall()">
        <span translate="tdWb.fpl.recall.CONFIRM"></span>
      </button>
    </div>
  </div>
</td-wb-modal-panel>
